const translate = function (value) {
  const translation = {
    'open': 'Otwarta',
    'draft': 'Szkic',
    'paid': 'Zapłacona',
    'closed': 'Zamknięta ',
    'true': 'TAK',
    'false': 'NIE',
    'agreement': 'Umowa',
    'annex': 'Załącznik do umowy',
    'cession': 'Zawiadomienie o cesji',
    'authorization': 'Upoważnienie inkasowe',
    'settlement': 'Rozliczenie',
    'final_settlement': 'Całkowite',
    'initial_settlement': 'Wstępne',
  }

  if (value instanceof Array) {
    let translated = []

    for (let i = 0; i < value.length; i++) {
      if (translation[value[i]] != undefined) {
        translated.push(translation[value[i]])
      } else {
        translated.push(value[i])
      }
    }

    return translated
  }
  if (translation[value] != undefined) {
    return translation[value]
  }
  return value
}

export default {
  translate
}


// WEBPACK FOOTER //
// ./src/utils/translation.js